"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Pressable", {
    enumerable: true,
    get: function() {
        return Pressable;
    }
});
function _reactnative() {
    const data = require("react-native");
    _reactnative = function() {
        return data;
    };
    return data;
}
const Pressable = _reactnative().Pressable;

//# sourceMappingURL=Pressable.js.map
